<template>
  <div>
    <div class="flex items-center gap-3">
      <div
        v-for="ent of options"
        :key="ent.value"
        class="flex items-center justify-center gap-1 cursor-pointer"
        @click="select(ent.value)"
      >
        <div class="blue-radio" :class="{ 'blue-radio--checked': props.modelValue === ent.value }">
          <div class="blue-radio__inner"></div>
        </div>
        <span>{{ ent.label }}</span>
      </div>
    </div>
    <div
      v-if="vErrors && vErrors.length > 0"
      class="text-red-500 text-base text-left pl-4 pt-1"
    >
      <div class="input-errors" v-for="error of vErrors" :key="error.$uid">
        <div class="error-msg">{{ error.$message }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: String,
  options: Array,
  label: String,
  name: String,
  validator: Object,
});

const emit = defineEmits(["update:modelValue"]);
const select = (value) => {
  emit("update:modelValue", value);
};

const fvalid = computed(() => props.validator && props.validator[props.name]);
const vErrors = computed(() => {
  return fvalid.value?.$errors;
});
</script>
<style scoped>
.blue-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #0e153b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fresh-water .blue-radio {
  background-color: #0f2416;
}
.blue-radio__inner {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color 0.15s;
}
.blue-radio--checked .blue-radio__inner {
  background-color: #16db8f;
}
</style>
